export enum IventisAggregationType {
    GroupBy = "GroupBy",
    Sum = "Sum"
}